const isMobile = window.innerWidth < 767; 
let spotHeight;
let spotWidth;
let mobileWidth = (window.innerWidth - 32).toString();
if (isMobile) {
  spotHeight = '343';
  spotWidth = mobileWidth;
} else {
  spotHeight = '480';
  spotWidth = '1550';
}

const homeQuery = `
{
  homeScreen {
    brandCarousel {
      title
      brandImage { url alt }
      brandLogo { url alt }
      storefrontLink { storefrontId }
      isExternalAffiliate
      dateAdded
      _createdAt
      justInDuration
      accessibilityLabel
      webOverrideLink
      cidField
      displayAdBadge
    }
    homepageHero {
      image { url }
      logoImageDesktop { url }
      logoImageMobile { url }
      logoSize
      primaryText
      subtext
      cta1Text
      cta2Text
      cta1Destination { webUrl cid }
      cta2Destination { webUrl cid }
    }
    promoCarousel {
      image { url }
      logoImage { url }
      logoSize
      header
      primaryText
      subtext
      accessibilityLabel
      doNotDisplayWeb
      displayAdBadge
      isExternalAffiliate
      destination { webUrl cid }
    }
    spotlightBanner {
      image {
        url(imgixParams: { h: ${spotHeight} w: ${spotWidth} fit: crop crop: entropy })
      }
      logoImage { url }
      logoSize
      primaryText
      subtext
      storefrontLink { storefrontId }
      customLink
      customLinkWeb
      cidField
      accessibilityLabel
      displayAdBadge
      isExternalAffiliate
    }
    feedCategories {
      handle
      text
    }
  }
  collectionScreen {
    collections {
      image { url }
      title
      collectionId
      accessibilityLabel
      cidFieldWeb
      customLinkWeb
      displayAdBadge
    }
    header {
      title
      subtitle
    }
  }
  spgContent {
    spgSpotlightImage {
      url(imgixParams: { h: ${spotHeight} w: ${spotWidth} fit: crop crop: entropy })
    }
    spgSpotlightLogo { url }
    spgSpotlightLogoSize
    spgSpotlightPrimaryText
    spgSpotlightSubtext
    spgSpotlightCustomLink
    spgSpotlightUtmCampaign
    spgSpotlightAccessibility
  }
  homeAffiliateCarousel {
    header {
      title
      subtitle
    }
		cards {
      title
      brandImage { url alt }
      brandLogo { url alt }
      storefrontLink { storefrontId }
      isExternalAffiliate
      dateAdded
      _createdAt
      accessibilityLabel
      webOverrideLink
      cidField
    }
  }
}
`;

const hpHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'Authorization': `Bearer 1099c1c0a613651c486503c8c1b934`,
  'X-Exclude-Invalid': true
};

function fetchHpDatoData(callback) {
  fetch('https://graphql.datocms.com/', {
    method: 'POST',
    headers: hpHeaders,
    body: JSON.stringify({ query: homeQuery }),
  })
  .then(res => res.json())
  .then(res => callback(res.data))
  .catch(error => console.log(error));
}

setTimeout(() => {
  fetchHpDatoData(data => {
    initBrands(data.homeScreen.brandCarousel);
    initColl(data.collectionScreen.collections, data.collectionScreen.header);
    initHero(data.homeScreen.homepageHero);
    initPromos(data.homeScreen.promoCarousel);
    initSpot(data.homeScreen.spotlightBanner[0]);
    initPage(data.spgContent);
    initAff(data.homeAffiliateCarousel.cards, data.homeAffiliateCarousel.header);
    // setPills(data.homeScreen.feedCategories);
  });
}, 500); 
